import styled from 'styled-components';

export const Container = styled.div`
  background-color: #181818;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 500px;
  margin-block: 10px;
  cursor: pointer;

   @media (max-width: 360px) {
      width: 95%;

    }
     @media (max-width: 768px) {
         width: 95%;
    }
`;
export const SubContainer = styled.div`
  display: flex;
  width: 95%;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  padding: 10px;
`;
export const ContainerFaix = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
`;
export const Title = styled.h1`
  color: ${({ theme }) => theme.COLORS.TITLE};
  font-size: 15px;
  margin-left: 10px;
  font-weight: 700;
  text-align: center;
  margin: 0;
  padding: 10px;

      @media (max-width: 360px) {
       font-size: 15px;
      padding: 0
    }
      @media (max-width: 768px) {
       font-size: 15px;
       padding: 0
    }
`;
export const Plan = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
`;
export const PlanText = styled.h3`
   color: ${({ theme }) => theme.COLORS.TITLE};
  font-size: 18px;
  font-weight: bold;
  margin: 0px 0px 0px 10px;
  padding: 0;

    @media (max-width: 360px) {
       font-size: 12px;
    }
      @media (max-width: 768px) {
       font-size: 14px;
    }
`;
export const Price = styled.p`
   color: ${({ theme }) => theme.COLORS.TITLE};
  font-size: 16px;
  margin-bottom: 10px;
  padding: 0;
  margin: 0;
`;
export const PriceTag = styled.div`
  background-color: ${({ theme }) => theme.COLORS.PRIMARY};
   color: ${({ theme }) => theme.COLORS.TITLE};
  font-size: 20px;
  font-weight: bold;
  padding: 10px 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  margin-left: auto;
`;
export const PriceText = styled.p`
  font-size: 12px;
  margin-left: 10px;
  padding: 0;
  margin: 0;
`;
export const Cifrao = styled.p`
  font-size: 20px;
  margin-left: 10px;
  padding: 0;
  margin: 0;

      @media (max-width: 360px) {
       font-size: 15px;
    }
      @media (max-width: 768px) {
       font-size: 15px;
    }
`;
export const Value = styled.p`
  font-size: 40px;
  margin-left: 10px;
  padding: 0;
  margin: 0;

      @media (max-width: 360px) {
       font-size: 20px;
    }
      @media (max-width: 768px) {
       font-size: 30px;
    }
`;
export const SelectCircle = styled.div`
    width: 20px;
    height: 20px;
    border: 2px solid ${({ theme }) => theme.COLORS.TEXT_DETAILS};
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${({ theme }) => theme.COLORS.SUB_BACKGROUND};

      @media (max-width: 360px) {
    width: 15px;
    height: 15px;
    }
      @media (max-width: 768px) {
    width: 15px;
    height: 15px;
    }
`;
export const Circle = styled.div`
    width: 15px;
    height: 15px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${({ theme }) => theme.COLORS.PRIMARY};

      @media (max-width: 360px) {
    width: 12px;
    height: 12px;
    }
      @media (max-width: 768px) {
    width: 12px;
    height: 12px;
    }
`;